import type { Vehicle } from '@/types/vehicle'

interface ItemProps {
  item: Vehicle;
}

export const Item = ({ item }: ItemProps) => (
  <div className="flex flex-col">
    <span className="text-sm font-medium">{item.Number}</span>
    <div className="flex gap-2 items-center">
      <span className="text-xs text-default-400">{item.Model}</span>
      {item.Driver && (
        <>
          <span className="text-xs text-default-400">•</span>
          <span className="text-xs text-primary">{item.Driver.Name}</span>
        </>
      )}
    </div>
  </div>
)
